import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import {
  getAlgoliaDataHitsResults,
  getAlgoliaDataQueryId,
  getAlgoliaSearchIndice,
} from 'selectors/algolia2/data'
import { getAlgoliaUserToken } from 'selectors/user/cookie'
import { getIsMobileScreenWidth, getScreenIsReady } from 'selectors/screen'
import { getSponsoredItems } from 'selectors/page'
import { hasPrintsSelected } from '../selectors/facets'
import { getUserID, isSessionSet } from 'selectors/user/session'
import { getSearchQuery, getTitle } from '../selectors/seoContent'
import { SAArtwork } from 'types/Artwork'

const mapStateToProps = createStructuredSelector({
  algoliaIndice: getAlgoliaSearchIndice,
  algoliaQueryId: getAlgoliaDataQueryId,
  algoliaUserToken: getAlgoliaUserToken,
  artworks: getAlgoliaDataHitsResults,
  hasPrints: hasPrintsSelected,
  isMobileScreen: getIsMobileScreenWidth,
  isScreenReady: getScreenIsReady,
  sponsoredItems: getSponsoredItems,
  isSet: isSessionSet,
  userID: getUserID,
  title: getTitle,
  searchQuery: getSearchQuery,
})

export type ConnectorProps = {
  algoliaIndice: string
  algoliaQueryId: string
  algoliaUserToken: string
  artworks: ReadonlyArray<SAArtwork>
  hasPrints: boolean
  isMobileScreen: boolean
  isScreenReady: boolean
  sponsoredItems: Array<Record<string, any>>
  isSet: boolean
  userID: number
  title: string
  searchQuery: string
}

export default connect(mapStateToProps)
